import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import clsx from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {DiscountThunderIcon} from '~/icons/discount-thunder-icon'
import {ThumbUpSignaturePickIcon} from '~/icons/thumb-up-signature-pick-icon'

export interface DiscountTextInfoBadgeProps extends HTMLAttributes<HTMLDivElement> {
  haveDiscount?: boolean
}

export const DiscountTextInfoBadge: FunctionComponent<DiscountTextInfoBadgeProps> = ({haveDiscount, ...props}) => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse

  const translations = getTranslation(language)

  return (
    <div {...props}>
      <div
        className={clsx(
          'flex w-full shrink-0 flex-row items-center gap-1',
          haveDiscount ? 'bg-red-100' : 'bg-green-100',
        )}
      >
        {haveDiscount ? (
          <DiscountThunderIcon className="shrink-0" />
        ) : (
          <ThumbUpSignaturePickIcon className="[&>path]:fill-green-500" />
        )}
        <p>{translations.Badge.discountTextInfo(haveDiscount ? 'preTariff' : 'solid')}</p>
      </div>
    </div>
  )
}
